// 将重量单位为克的数值，转换为其他重量单位的数值
export const weightGToOther = (unitName, value, fix = 2) => {
  let result = 0;
  value = Number(value);

  switch (unitName) {
    case 'kg':
      result = Number((value / 1000).toFixed(fix));
      break;
    case 'lbs':
      result = weightKg2Lbs(value / 1000, fix);
      break;
  }
  return result;
};

// 将其他重量单位的数值，转换为重量单位为克的数值
export const weightToG = (unitName, value, fix = 2) => {
  let result = 0;
  value = Number(value);

  switch (unitName) {
    case 'kg':
      result = Number(value);
      break;
    case 'lbs':
      result = weightLbs2Kg(value, fix);
      break;
  }
  return Number((result * 1000).toFixed(fix));
};

export const weightKg2Lbs = (v = 0, fix = 2) => {
  return Number((v / 0.4536).toFixed(fix));
};

export const weightLbs2Kg = (v = 0, fix = 2) => {
  return Number((v * 0.4536).toFixed(fix));
};
